var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRitualsActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4687_1993)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.705 11.8682C22.6891 13.698 22.2732 15.5022 21.4863 17.1543",
    stroke: "#381e23",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0009 22.5722C10.5952 22.5722 9.20333 22.2953 7.90466 21.7574C6.60598 21.2194 5.42597 20.431 4.43201 19.4371C2.42462 17.4296 1.29688 14.707 1.29688 11.8682",
    stroke: "#381e23",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2338 21.7489C21.598 21.7489 22.7039 20.6431 22.7039 19.2788C22.7039 17.9146 21.598 16.8086 20.2338 16.8086C18.8696 16.8086 17.7637 17.9146 17.7637 19.2788C17.7637 20.6431 18.8696 21.7489 20.2338 21.7489Z",
    fill: "#ffc6e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2338 21.7489C21.598 21.7489 22.7039 20.6431 22.7039 19.2788C22.7039 17.9146 21.598 16.8086 20.2338 16.8086C18.8696 16.8086 17.7637 17.9146 17.7637 19.2788C17.7637 20.6431 18.8696 21.7489 20.2338 21.7489Z",
    stroke: "#381e23",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.98828 7.91618C2.34718 7.01929 2.82938 6.1768 3.42098 5.41309",
    stroke: "#381e23",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.59766 2.58048C7.52572 2.0446 8.5312 1.65573 9.57832 1.42773",
    stroke: "#381e23",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0127 7.91618C21.6539 7.01929 21.1717 6.1768 20.5801 5.41309",
    stroke: "#381e23",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4005 2.58048C16.4725 2.0446 15.467 1.65573 14.4199 1.42773",
    stroke: "#381e23",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.71484 13.0715L10.8317 16.2858C12.2984 12.0726 13.5199 10.2238 16.2863 7.71436",
    stroke: "#381e23",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4687_1993"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRitualsActive);
export default __webpack_public_path__ + "static/media/ritualsActive.43bc7b533c3cb8d2f93256c3a0b21227.svg";
export { ForwardRef as ReactComponent };